import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import InspectionTab from "./InspectionTabs";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Priority from "./prioity";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import DarkButton from "./../../Global/DarkButton";
import Colors from "./../../Global/colors";
const useStyles = makeStyles((theme) => ({
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    minWidth: 120,
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});
const top100Films = [
  { title: "Workplace Reopening Checklist", year: 1994 },
  { title: "Haccp", year: 1972 },
  { title: "Covid Test", year: 1974 },
];
const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function CustomizedDialogs({ onClose, data, newdata, users }) {
  const classes = useStyles();
  const [age, setAge] = React.useState("");
  const [newaction, addnewaction] = React.useState({
    description: "",
    user_id: "",
    due: "",
    priority: "",
  });
  const [open, setOpen] = React.useState(true);
  const [open1, setOpen1] = React.useState(false);

 
  const handleClose = () => {
    // setOpen(false);
    onClose();
  };
  const senddata = () => {
    newdata(newaction);
    onClose();
  };

 

  const handleClose1 = () => {
    setOpen1(false);
  };

  const handleOpen1 = () => {
    setOpen1(true);
  };
  console.log(data);
  return <div>
      {/* <Button variant="outlined" color="primary">
        Open dialog
      </Button> */}
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" style={{ background: Colors.globalColor9 }} onClose={handleClose}>
          New Action
        </DialogTitle>

        <div className="">
          <div className="textarea-action" style={{ padding: "0 10px" }}>
            <TextareaAutosize style={{ height: "100px", width: "100%", borderRadius: "5px" }} rowsMax={4} name="description" fullWidth value={newaction.description} onChange={(e) => addnewaction(
                  { ...newaction, description: e.target.value }
                )} aria-label="maximum height" placeholder="What do you want to be done ?" />
          </div>
          <div className="textarea-action" style={{ padding: "0 10px" }}>
            <Autocomplete id="country-select-demoss"  autoComplete='off' className="assignee-width" fullWidth options={users} autoHighlight getOptionLabel={(option) => `${option.first_name} ${option.last_name}`} renderOption={(option) => <React.Fragment>
                  {option.first_name} {option.last_name}
                </React.Fragment>} onChange={(e, v) => {
                console.log(e.target, v);
                addnewaction({ ...newaction, user_id: v });
              }} renderInput={(params) => <TextField {...params} size="small" label="Assignee" margin="normal" variant="outlined" />} />
          </div>
          <div className="textarea-action" style={{ padding: "0 10px" }}>
            <FormControl variant="outlined" className="priorityInput" style={{width:'100%'}}>
              <InputLabel id="demo-simple-select-outlined-label" style={{transform: "translate(14px, 12px)  scale(1)"}}>
                Priority
              </InputLabel>
              <Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" name="priority" label="Priority" value={newaction.priority} onChange={(e, value) => {
                  console.log(e, value);
                  addnewaction({ ...newaction, priority: e.target.value });
                }} >
                <MenuItem value={"none"}>None</MenuItem>
                <MenuItem value={"Low"}>Low</MenuItem>
                <MenuItem value={"Medium"}>Medium</MenuItem>
                <MenuItem value={"High"}>High</MenuItem>
              </Select>
            </FormControl>

            {/* <FormControl style={{ width: "100%", padding: "0px" }} className="priorityInput">
              <Select labelId="demo-controlled-open-select-label" id="demo-controlled-open-select" open={open1} size="small" name="priority" fullWidth variant="outlined" style={{ width: "100%", padding: "0px" }} value={newaction.priority} onClose={handleClose1} onOpen={handleOpen1} onChange={(e, value) => {
                  console.log(e, value);
                  addnewaction({ ...newaction, priority: e.target.value });
                }}>
                <MenuItem value={""}>Priority</MenuItem>
                <MenuItem value={"none"}>None</MenuItem>
                <MenuItem value={"Low"}>Low</MenuItem>
                <MenuItem value={"Medium"}>Medium</MenuItem>
                <MenuItem value={"High"}>High</MenuItem>
              </Select>
            </FormControl> */}
          </div>
          <div className="textarea-action" style={{ padding: "10px 10px" }}>
            <TextField id="datetime-local" label="Due Date" name="due" size="small" variant="outlined" type="datetime-local" value={newaction.due} style={{ width: "100%" }} onChange={(e) => {
                console.log(e.target);
                addnewaction({ ...newaction, due: e.target.value });
              }} InputLabelProps={{ shrink: true }} />
          </div>
          {/* <table class="details-table">
            <tr>
              <td className="custom-spacing">
                <b>Assignee</b>
              </td>
              <td className="table-truncate inspection-table">
                <div style={{ width: 300 }}>
                  <Autocomplete id="country-select-demoss" className="assignee-width" fullWidth options={users} autoHighlight getOptionLabel={(option) => `${option.first_name} ${option.last_name}`} renderOption={(option) => <React.Fragment>
                        {option.first_name} {option.last_name}
                      </React.Fragment>} onChange={(e, v) => {
                      console.log(e.target, v);
                      addnewaction({ ...newaction, user_id: v });
                    }} renderInput={(params) => <TextField {...params} size="small" label="Assignee" margin="normal" variant="outlined" />} />
                </div>
              </td>
            </tr>
            <tr>
              <td className="custom-spacing">
                <b>Priority</b>
              </td>
              <td>
                <FormControl className={classes.formControl}>
                  <InputLabel id="demo-controlled-open-select-label">
                    Priority
                  </InputLabel>
                  <Select labelId="demo-controlled-open-select-label" id="demo-controlled-open-select" open={open1} size="small" name="priority" fullWidth variant="outlined" style={{ width: "100%" }} value={newaction.priority} onClose={handleClose1} onOpen={handleOpen1} onChange={(e, value) => {
                      console.log(e, value);
                      addnewaction({
                        ...newaction,
                        priority: e.target.value,
                      });
                    }}>
                    <MenuItem value={"none"}>None</MenuItem>
                    <MenuItem value={"Low"}>Low</MenuItem>
                    <MenuItem value={"Medium"}>Medium</MenuItem>
                    <MenuItem value={"High"}>High</MenuItem>
                  </Select>
                </FormControl>
              </td>
            </tr>
            <tr>
              <td className="custom-spacing">
                <b>Due Date</b>
              </td>
              <td>
                <form noValidate>
                  <TextField id="datetime-local" label="Due Date" name="due" type="datetime-local" value={newaction.due} onChange={(e) => {
                      console.log(e.target);
                      addnewaction({ ...newaction, due: e.target.value });
                    }} InputLabelProps={{ shrink: true }} />
                </form>
              </td>
            </tr>
            <tr>
              <td className="custom-spacing">
                <b>Inspection</b>
              </td>
              <td>
                <div>
                  <b>{data?.schedule_title}</b>
                </div>
              </td>
            </tr>
          </table> */}
        </div>
        <DialogActions>
          {/* <DarkButton
            onClick={senddata}
          >
            Add Action
          </DarkButton> */}

          <Button variant="contained" type="submit" className="addBtn" component="span" style={{width:'100%'}} onClick={senddata}>
            {"Add Action"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>;
}
